import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center"
        style={{ background: "#0a1119" }}
      >
        <Loader2 className="animate-spin text-[#19a55c]" size={32} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

// Guest-only routes (login / register). If already authenticated, bounce home.
export const GuestRoute = ({ children }) => {
  const { user, checking } = useAuth();

  if (checking) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center"
        style={{ background: "#0a1119" }}
      >
        <Loader2 className="animate-spin text-[#19a55c]" size={32} />
      </div>
    );
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return children;
};
